// extracted by mini-css-extract-plugin
export var borderRadius = "_gd-4";
export var large = "_gd-3";
export var logoContainer = "_gd-0";
export var nameLogo = "_gd-2";
export var small = "_gd-1";